import Breakpoints from 'breakpoints-js';

// documentation: https://github.com/thecreation/breakpoints-js

// DOM ready
$(() => {
    let xs = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xs'), 10);
    let sm = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-sm'), 10);
    let md = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md'), 10);
    let lg = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-lg'), 10);
    let xl = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xl'), 10);

    Breakpoints.defaults = {
        // Extra small devices (phones)
        xs: {
            min: xs,
            max: sm - 1
        },
        // Small devices (tablets)
        sm: {
            min: sm,
            max: md - 1
        },
        // Medium devices (desktops)
        md: {
            min: md,
            max: lg - 1,
        },
        // Large devices (large desktops)
        lg: {
            min: lg,
            max: xl - 1
        },
        xl: {
            min: xl,
            max: Infinity
        }
    };
    Breakpoints();
});

